var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#7C39BF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32,34.8c-9.4,0-17-7.6-17-17s7.6-17,17-17s17,7.6,17,17S41.4,34.8,32,34.8z M32,6.5 c-6.3,0-11.3,5.1-11.3,11.3S25.7,29.2,32,29.2s11.3-5.1,11.3-11.3S38.3,6.5,32,6.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.3,63.2c-1.6,0-2.8-1.3-2.8-2.8c0-9.4-9.6-17-21.5-17s-21.5,7.6-21.5,17c0,1.6-1.3,2.8-2.8,2.8 s-2.8-1.3-2.8-2.8C4.8,47.8,17,37.7,32,37.7s27.2,10.2,27.2,22.7C59.2,61.9,57.9,63.2,56.3,63.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.a4021acbdab5226bb1e2ecb7e42993be.svg";
export { ForwardRef as ReactComponent };